export const dateToDateString = (date: Date): string => {
  return `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1)
    .toString()
    .padStart(2, '0')}/${date.getFullYear()}`;
};

export const dateToHourString = (date: Date): string => {
  return `${date.getHours().toString().padStart(2, '0')}:${date
    .getMinutes()
    .toString()
    .padStart(2, '0')}`;
};

export const dateToDateHourString = (date: Date): string => {
  return `${dateToDateString(date)} ${dateToHourString(date)}`;
};

export const dateToMonthString = (date: Date): string => {
  let month = date.getMonth().toString();

  switch (date.getMonth()) {
    case 0:
      month = 'Gennaio';
      break;
    case 1:
      month = 'Febbraio';
      break;
    case 2:
      month = 'Marzo';
      break;
    case 3:
      month = 'Aprile';
      break;
    case 4:
      month = 'Maggio';
      break;
    case 5:
      month = 'Giugno';
      break;
    case 6:
      month = 'Luglio';
      break;
    case 7:
      month = 'Agosto';
      break;
    case 8:
      month = 'Settembre';
      break;
    case 9:
      month = 'Ottobre';
      break;
    case 10:
      month = 'Novembre';
      break;
    case 11:
      month = 'Dicembre';
      break;
  }

  return month + ' ' + date.getFullYear();
};

export const secondsToFormattedTime = (totalSeconds: number): string => {
  const minutes = Math.max(Math.floor(totalSeconds / 60), 0);
  const seconds = Math.max(totalSeconds % 60, 0);

  return `${minutes}:${seconds.toString().padStart(2, '0')}`;
};

export const formatSecondsToHoursMinutesSeconds = (seconds: number): string => {
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const secs = seconds % 60;

  return hours > 0
    ? `${hours}h ${minutes}m`
    : minutes > 0
      ? secs !== 0
        ? `${minutes}m ${secs}s`
        : `${minutes}m`
      : `${secs}s`;
};
